import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Manager {
  id: string
  companyId: string
  firstName: string
  lastName: string
  email: string
  mobileNo: string
  status: 'active' | 'inactive'
  createdAt: string
}

const initialManagers: Manager[] = [
  {
    id: '1',
    companyId: 'comp-1',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    mobileNo: '+49 123 456 7890',
    status: 'active',
    createdAt: '2024-01-15',
  },
  {
    id: '2',
    companyId: 'comp-1',
    firstName: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@example.com',
    mobileNo: '+49 234 567 8901',
    status: 'active',
    createdAt: '2024-02-20',
  },
  {
    id: '3',
    companyId: 'comp-1',
    firstName: 'Michael',
    lastName: 'Johnson',
    email: 'michael.johnson@example.com',
    mobileNo: '+49 345 678 9012',
    status: 'active',
    createdAt: '2024-03-10',
  },
  {
    id: '4',
    companyId: 'comp-2',
    firstName: 'Sarah',
    lastName: 'Williams',
    email: 'sarah.williams@example.com',
    mobileNo: '+49 456 789 0123',
    status: 'active',
    createdAt: '2024-01-25',
  },
]

export const useManagersStore = defineStore('managers', () => {
  const managers = ref<Manager[]>(initialManagers)

  const getManagersByCompany = (companyId: string) => {
    return managers.value.filter((m) => m.companyId === companyId && m.status === 'active')
  }

  const getManager = (id: string) => {
    return managers.value.find((m) => m.id === id)
  }

  const addManager = (manager: Omit<Manager, 'id' | 'createdAt'>) => {
    const newManager: Manager = {
      ...manager,
      id: Date.now().toString(),
      createdAt: new Date().toISOString().split('T')[0],
    }
    managers.value.push(newManager)
    return newManager
  }

  const updateManager = (id: string, updates: Partial<Manager>) => {
    const index = managers.value.findIndex((m) => m.id === id)
    if (index !== -1) {
      managers.value[index] = { ...managers.value[index], ...updates }
    }
  }

  const deleteManager = (id: string) => {
    managers.value = managers.value.filter((m) => m.id !== id)
  }

  const reset = () => {
    managers.value = JSON.parse(JSON.stringify(initialManagers))
  }

  return {
    managers,
    getManagersByCompany,
    getManager,
    addManager,
    updateManager,
    deleteManager,
    reset,
  }
})
